import { VOTE_TYPES } from '../components/vote/vote';

export const BOOKLET_FETCH = 'BOOKLET/FETCH';
export const BOOKLET_FETCH_SUCCESS = 'BOOKLET/FETCH_SUCCESS';
export const BOOKLET_FETCH_FAILURE = 'BOOKLET/FETCH_FAILURE';
export const BOOKLET_EDIT = 'BOOKLET/EDIT';

export const BOOKLET_REMOVE_HERO_IMAGE = 'BOOKLET/REMOVE/HERO/IMAGE';
export const BOOKLET_REMOVE_HERO_IMAGE_SUCCESS =
  'BOOKLET/REMOVE/HERO/IMAGE/SUCCESS';
export const BOOKLET_REMOVE_HERO_IMAGE_FAILURE =
  'BOOKLET/REMOVE/HERO/IMAGE/FAILURE';

export const BOOKLET_CREATE_NEW_BOOKLET = 'BOOKLET/CREATE_NEW_BOOKLET';
export const BOOKLET_SAVE = 'BOOKLET/SAVE';
export const BOOKLET_SAVE_SUCCESS = 'BOOKLET/SAVE_SUCCESS';
export const BOOKLET_CREATE_EMPTY_BOOKLET = 'BOOKLET/CREATE_EMPTY_BOOKLET';
export const BOOKLET_CREATE_EMPTY_SECTION = 'BOOKLET/CREATE_EMPTY_SECTION';
export const BOOKLET_SET_LAZY_LOADING = 'BOOKLET/SET_LAZY_LOADING';
export const BOOKLET_SET_IMAGES_COUNT = 'BOOKLET/SET_IMAGES_COUNT';
export const BOOKLET_PRINT = 'BOOKLET/PRINT';

export const BOOKLET_SET_ARCHIVED = 'BOOKLET/SET_ARCHIVED';
export const BOOKLET_SET_ARCHIVED_SUCCESS = 'BOOKLET/SET_ARCHIVED_SUCCESS';
export const BOOKLET_SET_ARCHIVED_FAILURE = 'BOOKLET/SET_ARCHIVED_FAILURE';

export const BOOKLET_SECTION_SAVE = 'BOOKLET/SECTION/SAVE';
export const BOOKLET_SECTION_SAVE_SUCCESS = 'BOOKLET/SECTION/SAVE_SUCCESS';
export const BOOKLET_SECTION_EDIT = 'BOOKLET/SECTION/EDIT';
export const BOOKLET_SECTION_EDIT_LAYOUT = 'BOOKLET/SECTION/EDIT_LAYOUT';
export const BOOKLET_SECTION_DELETE = 'BOOKLET/SECTION/DELETE';
export const BOOKLET_SECTION_DELETE_SUCCESS = 'BOOKLET/SECTION/DELETE_SUCCESS';

export const BOOKLET_SECTION_FRAGMENT_ADD = 'BOOKLET/SECTION/FRAGMENT/ADD';
export const BOOKLET_SECTION_FRAGMENT_ADD_SUCCESS =
  'BOOKLET/SECTION/FRAGMENT/ADD_SUCCESS';
export const BOOKLET_SECTION_FRAGMENT_EDIT = 'BOOKLET/SECTION/FRAGMENT/EDIT';
export const BOOKLET_SECTION_FRAGMENT_DELETE =
  'BOOKLET/SECTION/FRAGMENT/DELETE';

export const BOOKLET_SECTION_CHILD_FRAGMENT_ADD =
  'BOOKLET/SECTION/CHILD_FRAGMENT/ADD';
export const BOOKLET_SECTION_CHILD_FRAGMENT_EDIT =
  'BOOKLET/SECTION/CHILD_FRAGMENT/EDIT';
export const BOOKLET_SECTION_CHILD_FRAGMENT_EDIT_SUCCESS =
  'BOOKLET/SECTION/CHILD_FRAGMENT/EDIT_SUCCESS';
export const BOOKLET_SECTION_CHILD_FRAGMENT_EDIT_FAILURE =
  'BOOKLET/SECTION/CHILD_FRAGMENT/EDIT_FAILURE';
export const BOOKLET_SECTION_CHILD_FRAGMENT_DELETE =
  'BOOKLET/SECTION/CHILD_FRAGMENT/DELETE';
export const BOOKLET_SECTION_CHILD_FRAGMENT_ADD_SUCCESS =
  'BOOKLET/SECTION/CHILD_FRAGMENT/ADD_SUCCESS';
export const BOOKLET_SECTION_CHILD_FRAGMENT_ADD_FAILURE =
  'BOOKLET/SECTION/CHILD_FRAGMENT/ADD_FAILURE';

export const BOOKLET_TAG_DELETE = 'BOOKLET/TAG/DELETE';
export const BOOKLET_TAG_ADD = 'BOOKLET/TAG/ADD';

export const BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_EDIT =
  'BOOKLET/SECTION/FRAGMENT/COLLECTION_ITEM/EDIT';
export const BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_ADD =
  'BOOKLET/SECTION/FRAGMENT/COLLECTION_ITEM/ADD';
export const BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_DELETE =
  'BOOKLET/SECTION/FRAGMENT/COLLECTION_ITEM/DELETE';

export const BOOKLET_SECTION_FRAGMENT_VOTE = 'BOOKLET/SECTION/FRAGMENT/VOTE';
export const BOOKLET_SECTION_FRAGMENT_VOTE_SUCCESS =
  'BOOKLET/SECTION/FRAGMENT/VOTE_SUCCESS';
export const BOOKLET_SECTION_FRAGMENT_VOTE_FAILURE =
  'BOOKLET/SECTION/FRAGMENT/VOTE_FAILURE';
export const BOOKLET_SECTION_FRAGMENT_VOTE_DELETE =
  'BOOKLET/SECTION/FRAGMENT/VOTE/DELETE';
export const BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_SUCCESS =
  'BOOKLET/SECTION/FRAGMENT/VOTE/DELETE_SUCCESS';
export const BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_FAILURE =
  'BOOKLET/SECTION/FRAGMENT/VOTE/DELETE_FAILURE';

export const BOOKLET_COMMENT_ADD = 'BOOKLET/COMMENT/ADD';
export const BOOKLET_COMMENT_ADD_SUCCESS = 'BOOKLET/COMMENT/ADD_SUCCESS';
export const BOOKLET_COMMENT_ADD_FAILURE = 'BOOKLET/COMMENT/ADD_FAILURE';
export const BOOKLET_COMMENT_EDIT = 'BOOKLET/COMMENT/EDIT';
export const BOOKLET_COMMENT_EDIT_SUCCESS = 'BOOKLET/COMMENT/EDIT_SUCCESS';
export const BOOKLET_COMMENT_EDIT_FAILURE = 'BOOKLET/COMMENT/EDIT_FAILURE';
export const BOOKLET_COMMENT_DELETE = 'BOOKLET/COMMENT/DELETE';
export const BOOKLET_COMMENT_DELETE_SUCCESS = 'BOOKLET/COMMENT/DELETE_SUCCESS';
export const BOOKLET_COMMENT_DELETE_FAILURE = 'BOOKLET/COMMENT/DELETE_FAILURE';

export const BOOKLET_SHARED_FETCH = 'BOOKLET/SHARED/FETCH';
export const BOOKLET_SHARED_FETCH_SUCCESS = 'BOOKLET/SHARED/FETCH/SUCCESS';
export const BOOKLET_SHARED_FETCH_FAILURE = 'BOOKLET/SHARED/FETCH/FAILURE';

export const BOOKLET_GALLERY_IMAGES_ADD = 'BOOKLET/GALLERY/IMAGES_ADD';
export const BOOKLET_GALLERY_IMAGE_REMOVE = 'BOOKLET/GALLERY/IMAGE/REMOVE';

const initialState = {
  imagesCount: 0,
  isLazyLoadingEnabled: true,
  currentUserCommentsIds: [],
};

export const createEmptyBooklet = () => ({
  type: BOOKLET_CREATE_EMPTY_BOOKLET,
});

export const createNewBooklet = (booklet, returnToFirstStep) => ({
  type: BOOKLET_CREATE_NEW_BOOKLET,
  payload: { booklet, returnToFirstStep },
});

export const saveBooklet = booklet => ({
  type: BOOKLET_SAVE,
  payload: { booklet },
});

export const fetchBooklet = id => ({
  type: BOOKLET_FETCH,
  payload: { id },
});

export const fetchBookletShared = token => ({
  type: BOOKLET_SHARED_FETCH,
  payload: { token },
});

export const editBooklet = data => ({
  type: BOOKLET_EDIT,
  payload: data,
});

export const removeBookletHeroImage = data => ({
  type: BOOKLET_REMOVE_HERO_IMAGE,
  payload: data,
});

export const removeBookletHeroImageSuccess = () => ({
  type: BOOKLET_REMOVE_HERO_IMAGE_SUCCESS,
});

export const setArchived = (isArchived, bookletId, index) => ({
  type: BOOKLET_SET_ARCHIVED,
  payload: { isArchived, bookletId, index },
});

export const setLazyLoading = isLazyLoadingEnabled => ({
  type: BOOKLET_SET_LAZY_LOADING,
  payload: { isLazyLoadingEnabled },
});

export const setImagesCount = imagesCount => ({
  type: BOOKLET_SET_IMAGES_COUNT,
  payload: { imagesCount },
});

export const printBooklet = () => ({
  type: BOOKLET_PRINT,
});

export const saveSection = (bookletId, index, title, size) => ({
  type: BOOKLET_SECTION_SAVE,
  payload: { id: bookletId, index, title, size },
});

export const editSection = (index, bookletId, section) => ({
  type: BOOKLET_SECTION_EDIT,
  payload: { index, section, id: bookletId },
});

export const editSectionLayout = (index, section) => ({
  type: BOOKLET_SECTION_EDIT_LAYOUT,
  payload: { index, section },
});

export const deleteSection = (index, bookletId, sectionId) => ({
  type: BOOKLET_SECTION_DELETE,
  payload: { index, bookletId, sectionId },
});

export const addFragment = (sectionIndex, fragment, currentBreakpoint) => ({
  type: BOOKLET_SECTION_FRAGMENT_ADD,
  payload: { sectionIndex, fragment, currentBreakpoint },
});

export const editFragment = (
  sectionIndex,
  fragmentIndex,
  fragment,
  currentBreakpoint
) => ({
  type: BOOKLET_SECTION_FRAGMENT_EDIT,
  payload: { sectionIndex, fragmentIndex, fragment, currentBreakpoint },
});

export const addChildFragment = (
  sectionIndex,
  parentFragmentIndex,
  fragment
) => ({
  type: BOOKLET_SECTION_CHILD_FRAGMENT_ADD,
  payload: { sectionIndex, parentFragmentIndex, fragment },
});

export const editChildFragment = (
  sectionIndex,
  parentFragmentIndex,
  fragmentIndex,
  fragment
) => ({
  type: BOOKLET_SECTION_CHILD_FRAGMENT_EDIT,
  payload: { sectionIndex, parentFragmentIndex, fragmentIndex, fragment },
});

export const deleteChildFragment = (
  sectionIndex,
  parentFragmentIndex,
  fragmentIndex,
  fragmentId
) => ({
  type: BOOKLET_SECTION_CHILD_FRAGMENT_DELETE,
  payload: { sectionIndex, parentFragmentIndex, fragmentIndex, fragmentId },
});

export const addGalleryImages = (
  sectionIndex,
  parentFragmentIndex,
  images,
  id
) => ({
  type: BOOKLET_GALLERY_IMAGES_ADD,
  payload: { sectionIndex, parentFragmentIndex, images, id },
});

export const removeGalleryImage = (
  sectionIndex,
  parentFragmentIndex,
  fragmentIndex,
  fragmentId
) => ({
  type: BOOKLET_GALLERY_IMAGE_REMOVE,
  payload: { sectionIndex, parentFragmentIndex, fragmentIndex, fragmentId },
});

export const deleteFragment = (sectionIndex, fragmentIndex, fragmentId) => ({
  type: BOOKLET_SECTION_FRAGMENT_DELETE,
  payload: { sectionIndex, fragmentIndex, fragmentId },
});

export const addComment = (comment, bookletId, token) => ({
  type: BOOKLET_COMMENT_ADD,
  payload: { comment, bookletId, token },
});

export const editComment = (index, comment, fragment, bookletId, token) => ({
  type: BOOKLET_COMMENT_EDIT,
  payload: { index, comment, fragment, bookletId, token },
});

export const deleteComment = (comment, fragment, bookletId, token) => ({
  type: BOOKLET_COMMENT_DELETE,
  payload: { comment, fragment, bookletId, token },
});

export const fragmentVote = (
  bookletId,
  sectionId,
  sectionIndex,
  fragment,
  fragmentIndex,
  vote,
  childIndex,
  token
) => ({
  type: BOOKLET_SECTION_FRAGMENT_VOTE,
  payload: {
    bookletId,
    sectionId,
    sectionIndex,
    fragment,
    fragmentIndex,
    vote,
    childIndex,
    token,
  },
});

export const fragmentDeleteVote = (
  bookletId,
  sectionId,
  sectionIndex,
  fragment,
  fragmentIndex,
  childIndex,
  token
) => ({
  type: BOOKLET_SECTION_FRAGMENT_VOTE_DELETE,
  payload: {
    bookletId,
    sectionId,
    sectionIndex,
    fragment,
    fragmentIndex,
    childIndex,
    token,
  },
});

export const editFragmentCollectionItem = (
  sectionIndex,
  fragmentIndex,
  itemIndex,
  itemUpdate
) => ({
  type: BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_EDIT,
  payload: { sectionIndex, fragmentIndex, itemIndex, itemUpdate },
});

export const addFragmentCollectionItem = (
  sectionIndex,
  fragmentIndex,
  item
) => ({
  type: BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_ADD,
  payload: { sectionIndex, fragmentIndex, item },
});

export const deleteFragmentCollectionItem = (
  sectionIndex,
  fragmentIndex,
  itemIndex
) => ({
  type: BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_DELETE,
  payload: { sectionIndex, fragmentIndex, itemIndex },
});

export const deleteTag = tag => ({
  type: BOOKLET_TAG_DELETE,
  payload: { tag },
});

export const addTag = tag => ({
  type: BOOKLET_TAG_ADD,
  payload: { tag },
});

export const bookletReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_EDIT: {
      const { sectionIndex, fragmentIndex, itemIndex, itemUpdate } = payload;
      const section = state.sections[sectionIndex];
      const fragment = section.fragments[fragmentIndex];

      if (itemUpdate.url || itemUpdate.optional !== undefined) {
        //for images don't mutate items
        return {
          ...state,
          sections: [
            ...state.sections.slice(0, sectionIndex),
            {
              ...section,
              fragments: [
                ...state.sections[sectionIndex].fragments.slice(
                  0,
                  fragmentIndex
                ),
                {
                  ...fragment,
                  config: {
                    items: [
                      ...fragment.config.items.slice(0, itemIndex),
                      {
                        ...fragment.config.items[itemIndex],
                        ...itemUpdate,
                      },
                      ...fragment.config.items.slice(itemIndex + 1),
                    ],
                  },
                },
                ...state.sections[sectionIndex].fragments.slice(
                  fragmentIndex + 1
                ),
              ],
            },
            ...state.sections.slice(payload.sectionIndex + 1),
          ],
        };
      } else {
        fragment.config.items[itemIndex] = {
          ...fragment.config.items[itemIndex],
          ...itemUpdate,
        };

        return {
          ...state,
          sections: [
            ...state.sections.slice(0, sectionIndex),
            {
              ...section,
              fragments: [
                ...state.sections[sectionIndex].fragments.slice(
                  0,
                  fragmentIndex
                ),
                {
                  ...fragment,
                },
                ...state.sections[sectionIndex].fragments.slice(
                  fragmentIndex + 1
                ),
              ],
            },
            ...state.sections.slice(payload.sectionIndex + 1),
          ],
        };
      }
    }
    case BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_ADD: {
      const { sectionIndex, fragmentIndex, item } = payload;
      const section = state.sections[sectionIndex];
      const fragment = section.fragments[fragmentIndex];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, sectionIndex),
          {
            ...section,
            fragments: [
              ...state.sections[sectionIndex].fragments.slice(0, fragmentIndex),
              {
                ...fragment,
                config: {
                  ...fragment.config,
                  items: [
                    ...(fragment.config.items ? fragment.config.items : []),
                    item,
                  ],
                },
              },
              ...state.sections[sectionIndex].fragments.slice(
                fragmentIndex + 1
              ),
            ],
          },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SECTION_FRAGMENT_COLLECTION_ELEMENT_DELETE: {
      const { sectionIndex, fragmentIndex, itemIndex } = payload;
      const section = state.sections[sectionIndex];
      const fragment = section.fragments[fragmentIndex];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, sectionIndex),
          {
            ...section,
            fragments: [
              ...state.sections[sectionIndex].fragments.slice(0, fragmentIndex),
              {
                ...fragment,
                config: {
                  ...fragment.config,
                  items: fragment.config.items.splice(itemIndex, 1),
                },
              },
              ...state.sections[sectionIndex].fragments.slice(
                fragmentIndex + 1
              ),
            ],
          },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_TAG_DELETE: {
      const tags = state.tags.filter(tag => tag !== payload.tag);
      return {
        ...state,
        tags,
      };
    }
    case BOOKLET_TAG_ADD: {
      return {
        ...state,
        tags: [...state.tags, payload.tag],
      };
    }
    case BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_SUCCESS: {
      const { sectionIndex, fragmentIndex, childIndex = null } = payload;

      let fragment, fragments;

      if (childIndex !== null) {
        fragment =
          state.sections[sectionIndex].fragments[fragmentIndex].children[
            childIndex
          ];
      } else {
        fragment = state.sections[sectionIndex].fragments[fragmentIndex];
      }

      let { likeCounter, dislikeCounter, currentUserVote } = fragment;

      //decrease counter based on current vote
      if (currentUserVote === VOTE_TYPES.LIKE) {
        likeCounter--;
      } else {
        dislikeCounter--;
      }

      if (childIndex !== null) {
        const children = [
          ...state.sections[sectionIndex].fragments[
            fragmentIndex
          ].children.slice(0, childIndex),
          {
            ...state.sections[sectionIndex].fragments[fragmentIndex].children[
              childIndex
            ],
            currentUserVote: null,
            likeCounter,
            dislikeCounter,
          },
          ...state.sections[sectionIndex].fragments[
            fragmentIndex
          ].children.slice(childIndex + 1),
        ];

        fragments = [
          ...state.sections[sectionIndex].fragments.slice(0, fragmentIndex),
          {
            ...state.sections[sectionIndex].fragments[fragmentIndex],
            children,
          },
          ...state.sections[sectionIndex].fragments.slice(fragmentIndex + 1),
        ];
      } else {
        fragments = [
          ...state.sections[sectionIndex].fragments.slice(0, fragmentIndex),
          {
            ...state.sections[sectionIndex].fragments[fragmentIndex],
            currentUserVote: null,
            likeCounter,
            dislikeCounter,
          },
          ...state.sections[sectionIndex].fragments.slice(fragmentIndex + 1),
        ];
      }

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, sectionIndex),
          { ...state.sections[sectionIndex], fragments },
          ...state.sections.slice(sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SECTION_FRAGMENT_VOTE_SUCCESS: {
      const {
        sectionIndex,
        fragmentIndex,
        data: { likeCounter, dislikeCounter, currentUserVote },
        childIndex = null,
      } = payload;

      let fragments;

      if (childIndex !== null) {
        const children = [
          ...state.sections[sectionIndex].fragments[
            fragmentIndex
          ].children.slice(0, childIndex),
          {
            ...state.sections[sectionIndex].fragments[fragmentIndex].children[
              childIndex
            ],
            currentUserVote,
            likeCounter,
            dislikeCounter,
          },
          ...state.sections[sectionIndex].fragments[
            fragmentIndex
          ].children.slice(childIndex + 1),
        ];

        fragments = [
          ...state.sections[sectionIndex].fragments.slice(0, fragmentIndex),
          {
            ...state.sections[sectionIndex].fragments[fragmentIndex],
            children,
          },
          ...state.sections[sectionIndex].fragments.slice(fragmentIndex + 1),
        ];
      } else {
        fragments = [
          ...state.sections[sectionIndex].fragments.slice(0, fragmentIndex),
          {
            ...state.sections[sectionIndex].fragments[fragmentIndex],
            likeCounter,
            dislikeCounter,
            currentUserVote,
          },
          ...state.sections[sectionIndex].fragments.slice(fragmentIndex + 1),
        ];
      }

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, sectionIndex),
          { ...state.sections[sectionIndex], fragments },
          ...state.sections.slice(sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_COMMENT_ADD_SUCCESS: {
      const { item_name: fragmentId, id: commentId } = payload;

      const currentUserCommentsIds = [
        ...state.currentUserCommentsIds,
        commentId,
      ];

      const comments = {
        ...state.comments,
        ...{
          [fragmentId]: [
            ...(state.comments[fragmentId] ? state.comments[fragmentId] : []),
            payload,
          ],
        },
      };

      return { ...state, comments, currentUserCommentsIds };
    }
    case BOOKLET_COMMENT_EDIT_SUCCESS: {
      const comments = [
        ...state.comments[payload.fragment.name].slice(0, payload.index),
        payload.comment,
        ...state.comments[payload.fragment.name].slice(payload.index + 1),
      ];

      return {
        ...state,
        comments: {
          ...state.comments,
          ...{
            [payload.fragment.name]: comments,
          },
        },
      };
    }
    case BOOKLET_COMMENT_DELETE_SUCCESS: {
      const comments = state.comments[payload.fragment.name].filter(
        comment => comment.id !== payload.comment.id
      );

      return {
        ...state,
        comments: {
          ...state.comments,
          ...{
            [payload.fragment.name]: comments,
          },
        },
      };
    }
    case BOOKLET_SHARED_FETCH_SUCCESS:
    case BOOKLET_FETCH_SUCCESS: {
      return { ...payload, ...initialState };
    }
    case BOOKLET_FETCH_FAILURE: {
      console.error(BOOKLET_FETCH_FAILURE);
      return state;
    }
    case BOOKLET_CREATE_EMPTY_BOOKLET: {
      return {
        name: '',
        title: '',
        description: '',
        shooting_date: null,
        heroImage: {},
        sections: [
          {
            title: '',
            name: '',
            description: '',
            layouts: {},
            fragments: [],
          },
        ],
      };
    }
    case BOOKLET_EDIT: {
      return { ...state, ...payload };
    }
    case BOOKLET_REMOVE_HERO_IMAGE_SUCCESS: {
      return { ...state, heroImage: null };
    }
    case BOOKLET_REMOVE_HERO_IMAGE_FAILURE: {
      return { ...state, heroImage: { ...payload } };
    }
    case BOOKLET_SET_LAZY_LOADING: {
      return { ...state, ...payload };
    }
    case BOOKLET_SET_IMAGES_COUNT: {
      const { imagesCount } = payload;
      return { ...state, imagesCount };
    }
    case BOOKLET_CREATE_EMPTY_SECTION: {
      const sections = [
        ...state.sections,
        { size: payload.size, tags: [], fragments: [] },
      ];
      return { ...state, sections };
    }
    case BOOKLET_SECTION_SAVE_SUCCESS: {
      const { section } = payload;
      const exists = state.sections.find(({ id }) => section.id === id);
      if (exists || !section.id) {
        return { ...state };
      }
      const sections = [...state.sections, section];
      return { ...state, sections };
    }
    case BOOKLET_SECTION_EDIT_LAYOUT:
    case BOOKLET_SECTION_EDIT: {
      const { section, index } = payload;
      const sections = [
        ...state.sections.slice(0, index),
        { ...state.sections[index], ...section },
        ...state.sections.slice(index + 1),
      ];
      return { ...state, sections };
    }
    case BOOKLET_SECTION_DELETE_SUCCESS: {
      const sections = state.sections.filter(
        (section, index) => index !== payload.index
      );
      return { ...state, sections };
    }
    case BOOKLET_SECTION_FRAGMENT_ADD_SUCCESS: {
      const fragments = [
        ...state.sections[payload.sectionIndex].fragments,
        payload.fragment,
      ];
      return {
        ...state,
        sections: [
          ...state.sections.slice(0, payload.sectionIndex),
          {
            ...state.sections[payload.sectionIndex],
            fragments,
            layouts: payload.layouts,
          },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SECTION_FRAGMENT_EDIT:
      const fragments = [
        ...state.sections[payload.sectionIndex].fragments.slice(
          0,
          payload.fragmentIndex
        ),
        {
          ...state.sections[payload.sectionIndex].fragments[
            payload.fragmentIndex
          ],
          ...payload.fragment,
        },
        ...state.sections[payload.sectionIndex].fragments.slice(
          payload.fragmentIndex + 1
        ),
      ];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, payload.sectionIndex),
          { ...state.sections[payload.sectionIndex], fragments },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };

    case BOOKLET_SECTION_CHILD_FRAGMENT_EDIT_SUCCESS: {
      const section = state.sections[payload.sectionIndex];
      const parentFragment = section.fragments[payload.parentFragmentIndex];

      const children = [
        ...parentFragment.children.slice(0, payload.fragmentIndex),
        {
          ...payload.fragment,
        },
        ...parentFragment.children.slice(payload.fragmentIndex + 1),
      ];

      const fragments = [
        ...state.sections[payload.sectionIndex].fragments.slice(
          0,
          payload.parentFragmentIndex
        ),
        {
          ...parentFragment,
          children,
        },
        ...state.sections[payload.sectionIndex].fragments.slice(
          payload.parentFragmentIndex + 1
        ),
      ];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, payload.sectionIndex),
          { ...state.sections[payload.sectionIndex], fragments },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SECTION_CHILD_FRAGMENT_ADD_SUCCESS: {
      const section = state.sections[payload.sectionIndex];
      const parentFragment = section.fragments[payload.parentFragmentIndex];

      const fragments = [
        ...state.sections[payload.sectionIndex].fragments.slice(
          0,
          payload.parentFragmentIndex
        ),
        {
          ...parentFragment,
          children: [
            ...parentFragment.children,
            {
              ...payload.fragment,
            },
          ],
        },
        ...state.sections[payload.sectionIndex].fragments.slice(
          payload.parentFragmentIndex + 1
        ),
      ];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, payload.sectionIndex),
          { ...section, fragments },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SECTION_CHILD_FRAGMENT_DELETE: {
      const section = state.sections[payload.sectionIndex];
      const parentFragment = section.fragments[payload.parentFragmentIndex];

      const children = [
        ...parentFragment.children.slice(0, payload.fragmentIndex),
        ...parentFragment.children.slice(payload.fragmentIndex + 1),
      ];

      const fragments = [
        ...state.sections[payload.sectionIndex].fragments.slice(
          0,
          payload.parentFragmentIndex
        ),
        {
          ...parentFragment,
          children,
        },
        ...state.sections[payload.sectionIndex].fragments.slice(
          payload.parentFragmentIndex + 1
        ),
      ];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, payload.sectionIndex),
          { ...state.sections[payload.sectionIndex], fragments },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SECTION_FRAGMENT_DELETE: {
      const fragments = [
        ...state.sections[payload.sectionIndex].fragments.slice(
          0,
          payload.fragmentIndex
        ),
        ...state.sections[payload.sectionIndex].fragments.slice(
          payload.fragmentIndex + 1
        ),
      ];

      return {
        ...state,
        sections: [
          ...state.sections.slice(0, payload.sectionIndex),
          { ...state.sections[payload.sectionIndex], fragments },
          ...state.sections.slice(payload.sectionIndex + 1),
        ],
      };
    }
    case BOOKLET_SAVE_SUCCESS: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/booklet.reducer.js